module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "viewContainer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isComment),
      expression: "isComment"
    }]
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "30%",
      "display": "flex"
    },
    attrs: {
      "label": "店铺名称："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入店铺名称",
      "maxlength": "20"
    },
    model: {
      value: (_vm.mendianName),
      callback: function($$v) {
        _vm.mendianName = $$v
      },
      expression: "mendianName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "30%",
      "display": "flex"
    },
    attrs: {
      "label": "商品名称："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入商品名称",
      "maxlength": "20"
    },
    model: {
      value: (_vm.tradeName),
      callback: function($$v) {
        _vm.tradeName = $$v
      },
      expression: "tradeName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger",
      "cla": ""
    },
    on: {
      "click": _vm.chanxun
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("店铺评价")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin": "5px 10px 0 0"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.showAdd()
      }
    }
  }, [_vm._v(" 添加评价 ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.usersList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "64",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.userName))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户身份",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.userTypeName))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "店铺名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.shopName
          }
        }, [_vm._v(_vm._s(scope.row.shopName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.goodsName
          }
        }, [_vm._v(_vm._s(scope.row.goodsName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "店铺评分",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.score))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "评价内容",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.content
          }
        }, [_vm._v(_vm._s(scope.row.content))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "回复内容",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.replyContent
          }
        }, [_vm._v(_vm._s(scope.row.replyContent))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "评价时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.cTime))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "width": "280",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.emitinfo(scope.row)
            }
          }
        }, [_vm._v(" 回复 ")]), _vm._v(" "), _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.chakan(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        }), _vm._v(" 查看 ")]), _vm._v(" "), _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.deleteMerchant(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        }), _vm._v(" 删除 ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "current-page": _vm.pageIndex,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isStoreReviews),
      expression: "isStoreReviews"
    }],
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("店铺评价详情")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin": "5px 10px 0 0"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.closeisAdd
    }
  }, [_vm._v("返 回")])], 1), _vm._v(" "), _c('el-form', {
    staticClass: "decorationDiaryDiv"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "品牌店铺：",
      "label-width": "88px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "filterable": "",
      "disabled": _vm.decorationSeeDis
    },
    on: {
      "change": _vm.determine
    },
    model: {
      value: (_vm.brandStoreId),
      callback: function($$v) {
        _vm.brandStoreId = $$v
      },
      expression: "brandStoreId"
    }
  }, _vm._l((_vm.brandStoreArr), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "关联商品：",
      "label-width": "88px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "disabled": _vm.decorationSeeDis
    },
    model: {
      value: (_vm.relatedGoodsId),
      callback: function($$v) {
        _vm.relatedGoodsId = $$v
      },
      expression: "relatedGoodsId"
    }
  }, _vm._l((_vm.relatedGoodsArr), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "总体："
    }
  }, [_c('el-rate', {
    staticStyle: {
      "font-size": "30px"
    },
    attrs: {
      "colors": _vm.colorred,
      "texts": _vm.texts,
      "show-text": "",
      "disabled": _vm.decorationSeeDis
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "服务："
    }
  }, [_c('el-rate', {
    staticStyle: {
      "font-size": "30px"
    },
    attrs: {
      "colors": _vm.colorred,
      "texts": _vm.texts,
      "show-text": "",
      "disabled": _vm.decorationSeeDis
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "品质："
    }
  }, [_c('el-rate', {
    staticStyle: {
      "font-size": "30px"
    },
    attrs: {
      "colors": _vm.colorred,
      "texts": _vm.texts,
      "show-text": "",
      "disabled": _vm.decorationSeeDis
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('el-checkbox-group', {
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "disabled": _vm.decorationSeeDis
    },
    model: {
      value: (_vm.checkId),
      callback: function($$v) {
        _vm.checkId = $$v
      },
      expression: "checkId"
    }
  }, _vm._l((_vm.checkList), function(item) {
    return _c('el-checkbox', {
      key: item.id,
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "88%"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "纯文本框最多输入",
      "disabled": _vm.decorationSeeDis,
      "autosize": {
        minRows: 3,
        maxRows: 6
      },
      "show-word-limit": "",
      "maxlength": "1000"
    },
    model: {
      value: (_vm.rContent),
      callback: function($$v) {
        _vm.rContent = $$v
      },
      expression: "rContent"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上传视频："
    }
  }, [(_vm.videoSrc) ? _c('div', {
    staticClass: "videoClass"
  }, [_c('span', {
    staticClass: "previewingVideo",
    on: {
      "click": function($event) {
        return _vm.newSeevideo(_vm.videoSrc)
      }
    }
  }, [(_vm.videoImg) ? _c('img', {
    attrs: {
      "src": _vm.videoImg
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/img/spfm.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "iconcontainer"
  }, [_c('img', {
    staticClass: "playIcon",
    attrs: {
      "src": require("../../assets/img/play.png")
    }
  })])]), _vm._v(" "), (!_vm.decorationSeeDis && _vm.videoSrc) ? _c('img', {
    staticClass: "chahao",
    attrs: {
      "src": require("../../assets/img/aicon36.png")
    },
    on: {
      "click": function($event) {
        return _vm.delvideo()
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.decorationSeeDis && !_vm.videoSrc) ? _c('el-upload', {
    staticClass: "avatar-uploader-zstp",
    attrs: {
      "action": "",
      "accept": "video/*",
      "before-upload": _vm.handleFile
    }
  }, [(_vm.videoFlag) ? _c('el-progress', {
    attrs: {
      "type": "circle",
      "percentage": _vm.videoUploadPercent,
      "width": 80,
      "height": 80
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("视频格式仅支持: mp4. 视频大小不能超过 50MB !")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上传图片："
    }
  }, [_c('div', {
    staticClass: "upPictures"
  }, [_vm._l((_vm.detailImgUrlarr), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "multigraph",
      attrs: {
        "data-img": item
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": item,
        "fit": "cover",
        "preview-src-list": _vm.detailImgUrlarr,
        "z-index": 9999
      },
      on: {
        "click": _vm.handleClickItem
      }
    }), _vm._v(" "), (!_vm.decorationSeeDis) ? _c('div', {
      staticClass: "chahao",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deldetail(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/aicon36.png")
      }
    })]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.flag < 15) ? _c('el-upload', {
    attrs: {
      "action": "",
      "multiple": "",
      "before-upload": _vm.beforeAvatarUpload,
      "accept": ".png, .jpg,.jpeg"
    }
  }, [(!_vm.decorationSeeDis) ? _c('i', {
    staticClass: "el-icon-plus upBtn"
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("最多上传15张照片, 商品详情图尺寸为支持jpg、png等格式 ")])], 2)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "label": "发布人昵称：",
      "label-width": "88px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入发布人昵称",
      "maxlength": "15",
      "disabled": _vm.decorationSeeDis
    },
    model: {
      value: (_vm.PublisherNickname),
      callback: function($$v) {
        _vm.PublisherNickname = $$v
      },
      expression: "PublisherNickname"
    }
  })], 1), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "canvasa",
      "hidden": "",
      "width": "1000",
      "height": "1000"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "label": "发布人头像：",
      "label-width": "88px"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "accept": ".jpg, .png",
      "show-file-list": false,
      "before-upload": _vm.beforeHeadImg,
      "disabled": _vm.decorationSeeDis
    }
  }, [(_vm.pubHeadPortImg) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.pubHeadPortImg
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v(" 建议上传的图片必须是宽高比例为1:1 ")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "label": "发布时间：",
      "label-width": "88px"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "80%",
      "cursor": "pointer"
    },
    attrs: {
      "type": "date",
      "editable": false,
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions,
      "placeholder": "选择日期",
      "disabled": _vm.decorationSeeDis
    },
    model: {
      value: (_vm.releaseTime),
      callback: function($$v) {
        _vm.releaseTime = $$v
      },
      expression: "releaseTime"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gudingdibu"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.closeisAdd()
      }
    }
  }, [_vm._v("返 回")]), _vm._v(" "), (!_vm.decorationSeeDis) ? _c('el-button', {
    attrs: {
      "type": "danger",
      "loading": _vm.loadingBut
    },
    on: {
      "click": function($event) {
        return _vm.Submit()
      }
    }
  }, [_vm._v(_vm._s(_vm.loadingButText))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "商家回复",
      "width": "30%",
      "visible": _vm.isToExamine,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.isToExamine = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入回复内容",
      "maxlength": "100",
      "rows": 3
    },
    model: {
      value: (_vm.shenmark),
      callback: function($$v) {
        _vm.shenmark = $$v
      },
      expression: "shenmark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0",
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.isToExamine = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.endToExamine()
      }
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择发布人",
      "visible": _vm.dialogVisibledis,
      "width": "45%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibledis = $event
      }
    }
  }, [_c('el-form', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "50%",
      "margin-right": "10px"
    },
    attrs: {
      "label": "发布人手机号："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入发布人手机号"
    },
    model: {
      value: (_vm.publisherPhone),
      callback: function($$v) {
        _vm.publisherPhone = $$v
      },
      expression: "publisherPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.finddes()
      }
    }
  }, [_vm._v("查 询")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "disoutline"
  }, [_vm._l((_vm.publisherArr), function(item, index) {
    return _c('p', {
      key: index,
      staticClass: "disinline",
      on: {
        "click": function($event) {
          return _vm.handleGetdesId(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.faceUrl
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.nickName))]), _vm._v(" "), _c('el-radio', {
      staticClass: "elRadio",
      attrs: {
        "label": item.id
      },
      model: {
        value: (_vm.choiceRadioId),
        callback: function($$v) {
          _vm.choiceRadioId = $$v
        },
        expression: "choiceRadioId"
      }
    }, [_vm._v("选择")])], 1)
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noPublisherData),
      expression: "noPublisherData"
    }],
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("查无结果")])], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisibledis = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.makedes()
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "视频播放",
      "visible": _vm.videoVisible,
      "width": "30%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.videoVisible = $event
      },
      "close": _vm.closeVideo
    }
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "video-player vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptions
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "图片剪裁",
      "visible": _vm.cropping,
      "append-to-body": "",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.cropping = $event
      }
    }
  }, [_c('div', {
    staticClass: "cropper-content"
  }, [_c('div', {
    staticClass: "cropper"
  }, [_c('vueCropper', {
    ref: "cropper",
    attrs: {
      "img": _vm.option.img,
      "outputSize": _vm.option.size,
      "fixedBox": _vm.option.fixedBox,
      "outputType": _vm.option.outputType,
      "full": _vm.option.full,
      "canMove": _vm.option.canMove,
      "infoTrue": _vm.option.infoTrue,
      "canMoveBox": _vm.option.canMoveBox,
      "original": _vm.option.original,
      "autoCrop": _vm.option.autoCrop,
      "info": true,
      "fixed": _vm.option.fixed,
      "fixedNumber": _vm.option.fixedNumber,
      "centerBox": _vm.option.centerBox,
      "autoCropWidth": _vm.option.autoCropWidth,
      "autoCropHeight": _vm.option.autoCropHeight
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.cropping = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v("确认")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3195c400!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/contentManagement/storeReviews.vue
// module id = 1669
// module chunks = 3